import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BaseChart } from 'react-jsx-highcharts';

var HighchartsStockChart =
/*#__PURE__*/
function (_Component) {
  _inherits(HighchartsStockChart, _Component);

  function HighchartsStockChart() {
    _classCallCheck(this, HighchartsStockChart);

    return _possibleConstructorReturn(this, _getPrototypeOf(HighchartsStockChart).apply(this, arguments));
  }

  _createClass(HighchartsStockChart, [{
    key: "render",
    value: function render() {
      return React.createElement(BaseChart, _extends({}, this.props, {
        chartCreationFunc: this.props.getHighcharts().stockChart,
        chartType: "stockChart"
      }));
    }
  }]);

  return HighchartsStockChart;
}(Component);

export default HighchartsStockChart;